import {useStyles} from '@wix/tpa-settings/react'
import classNames from 'classnames'
import React from 'react'
import stylesParams from '../../../stylesParams'
import {PromotionalBadgeProps} from './interfaces'
import s from './promotional-badge.scss'

export const PromotionalBadge = ({onImage}: PromotionalBadgeProps) => {
  const {get} = useStyles()

  const fullWidth = get(stylesParams.promotionalBadgeStretched)

  return (
    <div className={onImage ? s.container : undefined}>
      <div data-hook="promotional-badge" className={classNames(s.badge, {[s.fullWidth]: onImage && fullWidth})}>
        <div>Selling out fast!</div>
      </div>
    </div>
  )
}
